<template>
	<div style="background: #F6F6F6;" v-if="loding">
		<projectHead></projectHead>
		<div class="wrap">
			<div class="header">
				<div style="display: flex;align-items: center;"><img src="../../assets/images/indexIcon.png" alt="">
					<p><span>首页-项目需求池</span>-{{proDetail.title}}</p>
				</div>
				<div class="backof" @click="$router.go(-1)">返回</div>
			</div>
			<div class="body">
				<div class="body-left">
					<div class="left-head">
						发布人信息
					</div>
					<div class="left-body" v-if="proDetail.user_info != null">
						<div class="body-item">
							<div @click="goto(`/geniusClub/geniusInfo?id=${proDetail.user_info.id}`)" class="item-title">
								{{proDetail.user_info.nickname}}
							</div>
							<div  v-if="isf==0"  class="item-content">
								联系方式:{{proDetail.user_info.mobile.slice(0, 3) + '****' + proDetail.user_info.mobile.slice(7) || proDetail.user_info.email}}
							</div>
							<div  v-if="isf==1"  class="item-content">
								联系方式:{{proDetail.user_info.mobile || proDetail.user_info.email}}
							</div>
						</div>
						<div class="body-item">
							<div class="item-title">
								<!-- {{proDetail.user_record.company}} -->
							</div>
							<!-- <div class="item-content">
								清华大学 <span style="color: #0052D9;margin-left: 5px;cursor:pointer;"
									@click="$router.push(`/geniusClub/companyInfo?id=${1}`)">(已认证)</span>
							</div> -->
							<!-- <div class="item-content">
								北京科技 <span style="margin-left: 5px;">(未认证)</span>
							</div> -->
						</div>
						<div class="body-item">
							<div class="item-title">
								公司评价
							</div>
							<div class="item-content">
								暂无
							</div>
						</div>
						<div class="body-item">
							<div class="item-title">
								用户报价
							</div>
							<div class="item-content">
								{{proDetail.price_see ? proDetail.price : '无权查看'}}
							</div>
						</div>

						<!-- 	<div class="guanzhu">
							关注公司
						</div> -->
					</div>
					<div class="left-body" v-else>
						<div class="body-item">
							<div  @click="goto(`/geniusClub/geniusInfo?id=${proDetail.user_info.id}`)" class="item-title">
								{{proDetail.user_record.name}}
							</div>
							<div v-if="isf==0" class="item-content">
								联系方式:{{proDetail.user_record.phone.slice(0, 3) + '****' + proDetail.user_record.phone.slice(7) || proDetail.user_record.email}}
							</div>
							<div v-if="isf==1" class="item-content">
								联系方式:{{proDetail.user_record.phone|| proDetail.user_record.email}}
							</div>
						</div>
						<div class="body-item">
							<div class="item-title">
								{{proDetail.user_record.company}}
							</div>
							<!-- <div class="item-content">
								清华大学 <span style="color: #0052D9;margin-left: 5px;cursor:pointer;"
									@click="$router.push(`/geniusClub/companyInfo?id=${1}`)">(已认证)</span>
							</div> -->
							<!-- <div class="item-content">
								北京科技 <span style="margin-left: 5px;">(未认证)</span>
							</div> -->
						</div>
						<div class="body-item">
							<div class="item-title">
								公司评价
							</div>
							<div class="item-content">
								暂无
							</div>
						</div>
						<!-- 	<div class="guanzhu">
							关注公司
						</div> -->
					</div>
				</div>
				<div class="body-main">
					<div class="main-head">
						<div class="head-left">
							<img :src='getImgSrc(proDetail.image)' style="width: 238px;height: 238px;" alt="">
						</div>
						<div class="head-right">
							<div class="title">
								{{proDetail.title}}
							</div>
							<div class="introduce">
								<div>科学类别：{{proDetail.subjectcate_name}}</div>
								<div>行业类别：{{proDetail.industry_name}}</div>
								<div>更新时间：{{timeConversion(proDetail.createtime)}}</div>
							</div>
							<div class="content">
								<p v-html="formatRichText(proDetail.summary_info)"></p>
							</div>
							<div class="bottom">
								<span style="color: #0052D9;"><i class="el-icon-view"
										style="font-size: 20px;"></i>{{proDetail.hits}}</span>
								<span style="margin-left: 20px;cursor: pointer;" @click="handleLike"
									:style="proDetail.collect == 1 ?'color: #0052D9;':''"><i class="el-icon-star-on"
										style="font-size:20px;"></i>{{proDetail.collect_num}}</span>
							</div>
						</div>
					</div>
					<div class="main-body">
						<div class="body-item">
							<div style="background:#E5EDFB;">
								<div
									style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
									基本信息
								</div>
							</div>
							<div class="item-detail">
								<p v-html="formatRichText(proDetail.summary_info)"></p>
								<div class="detail-line" v-for="(item,index) in files">
									<p>{{proDetail.title }}</p>
									<!-- <a :href="getImgSrc(item)" download="">下载</a> -->
									<span @click="getPath(item)">下载</span>
								</div>

							</div>
						</div>
						<div class="body-item">
							<div style="background:#E5EDFB;">
								<div
									style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
									完整版信息
								</div>
							</div>
							<div class="item-detail">
								<p v-html="formatRichText(proDetail.project_need_info)"></p>
							</div>
						</div>
						<div class="body-item">
							<div style="background:#E5EDFB;">
								<div
									style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
									项目状态
								</div>
							</div>
							<div class="item-detail">
								<!-- //状态:1=待审核,2=公布中,3=已投条,4=执行中,5=已归档,6=已存挡 -->
								<div class="detail-line" v-if="proDetail.status == 1">
									待审核
								</div>
								<div class="detail-line" v-if="proDetail.status == 2">
									公布中
								</div>
								<div class="detail-line" v-if="proDetail.status == 3">
									已投条
								</div>
								<div class="detail-line" v-if="proDetail.status == 4">
									执行中
								</div>
								<div class="detail-line" v-if="proDetail.status == 5">
									已归档
								</div>
								<div class="detail-line" v-if="proDetail.status == 6">
									已存挡
								</div>
							</div>
						</div>
					</div>
				</div>
				<el-dialog title="请输入密码验证" :visible.sync="centerDialogVisible" width="30%" center>
					<div style="background:#444C69;margin: 0 auto;text-align: center;height: 40px;color: white;margin-top: 20px;"
						@click="goto(`/userCenter/PTHD/myMessage?type=3&id=${proDetail.user_id}`)">
						<span style="width:80px;display: inline-block;
    margin-top: 11px;">联系发布人</span>
					</div>
					<el-input style="font-size:16px;" placeholder="请输入密码" v-model="downLoadPWD"> </el-input>
					<span slot="footer" class="dialog-footer">
						<el-button @click="centerDialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="verifyDownPwd">确 定</el-button>
					</span>
				</el-dialog>
				<div class="body-right">
					<div style="background: #FF8F00;" @click="handleLike">
						<img src='../../assets/images/whiteStar.png' alt="" style="width: 18px;height: 18px;"><span
							style="width:80px">收藏</span>
					</div>
					<!-- <div style="background: #929292;"  @click="handleLike" >
						<img src='../../assets/images/whiteStar.png' alt="" style="width: 18px;height: 18px;"><span
							style="width:80px">取消收藏</span>
					</div> -->
					<div style="background: #3399FF;position: relative;" class="shareBox">
						<img src='../../assets/images/share.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">分享</span>
						<div class="share"
							style="position: absolute;left:0px;background: rgba(255, 255, 255, 0);width: 200px;display: flex;align-items: center;justify-content: center;height: 50px;">
							<goShare :zytitle='proDetail.title'></goShare>
							<!-- :imageSrc='getImgSrc(proDetail.image)' -->
						</div>
					</div>

					<div style="background:#444C69;"
						@click="goto(`/userCenter/PTHD/myMessage?type=3&id=${proDetail.user_id}&zuozhe=${proDetail.user_info.nickname}&biaoti=${proDetail.title}`)">
						<img src='../../assets/images/circlewen.png' alt="" style="width: 19px;height: 19px;">
						<span style="width:80px">咨询作者</span>
					</div>
					<div v-if="this.user_id != proDetail.user_id&&proDetail.status<5" style="background:#929292;"
						@click="goto(`/projectNeed/yiFangDj?id=${$route.query.id}&type=wyyy`)">
						<img src='../../assets/images/heart.png' alt="" style="width: 18px;height: 16px;"><span
							style="width:80px">我有意愿</span>
					</div>
					<div  v-if="this.user_id != proDetail.user_id&&proDetail.status>3" style="background:blue;" @click="showDialog = true">
						<img src='../../assets/images/zixun.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">仲裁申请</span>
					</div>
					<div  v-if="this.user_id != proDetail.user_id&&proDetail.status>3" style="background:red;" @click="showDialog1 = true">
						<img src='../../assets/images/zixun.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">专家评审</span>
					</div>
					<!-- <div  style="background:brown;" @click="showDialog2 = true">
						<img src='../../assets/images/zixun.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">提交问题</span>
					</div> -->
					<!-- <share :config="share_config"></share> -->
					<div v-if="showDialog" class="dialog-overlay">
						<div class="dialog-content">  
						<textarea style="height: 300px;" v-model="correctionSuggestions" placeholder="在这里输入您的仲裁申请说明!"></textarea>  
						<div class=".dialog-footer">
						  <button  class="submit-btn" @click="submitCorrections">提交</button>  
						  <button  class="cancel-btn" @click="showDialog = false">取消</button>
						</div>
						</div>  
					</div>
					<div v-if="showDialog1" class="dialog-overlay">
						<div class="dialog-content">  
						<textarea style="height: 300px;" v-model="correctionSuggestions1" placeholder="在这里输入您的专家评审说明!"></textarea>  
						<div class=".dialog-footer">
						  <button  class="submit-btn" @click="submitCorrections1">提交</button>  
						  <button  class="cancel-btn" @click="showDialog1 = false">取消</button>
						</div>
						</div>  
					</div>
					<div v-if="showDialog2" class="dialog-overlay">
						<div class="dialog-content">  
						<textarea style="height: 300px;" v-model="correctionSuggestions2" placeholder="在这里输入您的问题!"></textarea>  
						<div class=".dialog-footer">
						  <button  class="submit-btn" @click="submitCorrections2">提交</button>  
						  <button  class="cancel-btn" @click="showDialog2 = false">取消</button>
						</div>
						</div>  
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>
<script>
	import goShare from '../../components/share.vue'
	import projectHead from '../../components/projectHead'
	let that = this
	export default {
		computed: {  
		    userInfo() {  
		      return this.$store.state.userInfo;  
		    },  
		  },  
		components: {
			projectHead,
			goShare
		},
		data() {
			return {
				showDialog: false,
				correctionSuggestions: '',
				showDialog1: false,
				correctionSuggestions1: '',
				showDialog2: false,
				correctionSuggestions2: '',
				user_id:'',
				centerDialogVisible: false,
				shoucang: false,
				whereForm: "",
				title: '开源海洋观测数据分析',
				proDetail: '',
				files: [],
				downLoadPWD: "",
				downLoadPath: '',
				loding: false,
				canLike: true,
				isf:0
			}
		},
		created() {
			
			this.getDetail(this.$route.query.id)
			// this.isfriend()
		},

		mounted() {
			// 获取 userInfo（如果需要解析为对象）  
			    const userInfoStr = sessionStorage.getItem('userInfo');  
			    if (userInfoStr) {  
			      const userInfo = JSON.parse(userInfoStr);
				   this.user_id = userInfo.user_id
			      console.log('当前登录用户信息',userInfo); // 现在你可以使用 userInfo 对象了  
			    }  
		},
		beforeRouteEnter(to, from, next) {
			// that.whereForm = from.meta.title
			next(vm => {
				vm.$data.whereForm = from.meta.title
			});
		},
		methods: {
			// //判断是否是好友
			async isfriend() {
			    
			}, 
			//仲裁申请
			submitCorrections() {
			      // 调用 jiucuo 方法来提交建议  
			      this.jiucuo();  
			}, 
			//专家评审
			submitCorrections1() {
			      // 调用 jiucuo 方法来提交建议  
			      this.jiucuo1();  
			}, 
			//提交问题
			submitCorrections2() {
			      // 调用 jiucuo 方法来提交建议  
			      this.jiucuo2();  
			}, 
			async jiucuo(){
				if(!this.correctionSuggestions){
					this.$message({
						message: "输入您的仲裁申请说明 ! ", 
						type: 'success',
					})
				}
				const alike = await this.$api.add_zhongcai({
					user_id:this.proDetail.user_id,
					pro_id:this.proDetail.id,
					pro_title:this.proDetail.title,
					prostatus:3,
					jccontent:this.correctionSuggestions,
					})
				if(alike.code == 1){
					this.$message({
						message: alike.msg,
						type: 'success',
					})
					this.showDialog = false;  
					this.correctionSuggestions = ''; // 清空输入框
				}else{
					this.$message({
						message: alike.msg,
						type: 'warning',
					})
				}
				// this.alike = alike.data
				console.log('下架信息',alike);
			},
			async jiucuo1(){
				if(!this.correctionSuggestions1){
					this.$message({
						message: "输入您的专家评审说明 ! ", 
						type: 'success',
					})
				}
				const alike = await this.$api.add_zhuanjiapingshen({
					user_id:this.proDetail.user_id,
					pro_id:this.proDetail.id,
					pro_title:this.proDetail.title,
					prostatus:3,
					jccontent:this.correctionSuggestions1,
					})
				if(alike.code == 1){
					this.$message({
						message: alike.msg,
						type: 'success',
					})
					this.showDialog1 = false;  
					this.correctionSuggestions1 = ''; // 清空输入框
				}else{
					this.$message({
						message: alike.msg,
						type: 'warning',
					})
				}
				// this.alike = alike.data
				console.log('下架信息',alike);
			},
			async jiucuo2(){
				if(!this.correctionSuggestions2){
					this.$message({
						message: "输入您的问题 ! ", 
						type: 'success',
					})
				}
				const alike = await this.$api.add_changjianwenti({
					user_id:this.proDetail.user_id,
					// pro_id:this.proDetail.id,
					// pro_title:this.proDetail.title,
					cate_list:1,
					question:this.correctionSuggestions2,
					})
				if(alike.code == 1){
					this.$message({
						message: alike.msg,
						type: 'success',
					})
					this.showDialog2 = false;  
					this.correctionSuggestions2 = ''; // 清空输入框
				}else{
					this.$message({
						message: alike.msg,
						type: 'warning',
					})
				}
				// this.alike = alike.data
			},
			async getDetail(id) {
				const detail = await this.$api.projectneedGetDetail({
					id: id
				})
				this.proDetail = detail.data
				console.log('项目详情',detail.data);
				if (detail.data.project_need_files) {
					this.files = detail.data.project_need_files.split(",")
				}
				this.loding = true
				const res = await this.$api.isfriendis({
				  	projectneeduserid:this.proDetail.user_id,
				  	})
					// console.log('是否是好友',res.data)
				if(res.data==1){
					this.isf = 1;
					console.log('是否是好友',res.data)
				}
			},
			getPath(item) {
				this.downLoadPath = item
				this.centerDialogVisible = true
				// if(this.downLoadPWD == this.proDetail.password){
				// 	this.centerDialogVisible = false
				// }
			},
			handleLike() {
				if (this.canLike) {
					this.canLike = false;

					// 发送点赞请求
					this.collectHandler();

					// 设置节流延迟
					setTimeout(() => {
						this.canLike = true;
					}, 1000);
				}
			},
			async collectHandler(id) {
				if (this.proDetail.collect) {
					const collect = await this.$api.productCancelCollect({
						id: this.proDetail.id
					})
					if (collect.code == 1) {
						this.$message({
							message: '取消收藏',
							type: 'warning',
							center: true
						})
						this.proDetail.collect = 0
						this.proDetail.collect_num -= 1
					}
				} else {
					const collect = await this.$api.productCollect({
						id: this.proDetail.id
					})
					if (collect.code == 1) {
						this.$message({
							message: '收藏成功',
							type: 'success',
							center: true
						})
						this.proDetail.collect = 1
						this.proDetail.collect_num += 1
					}
				}
			},
			verifyDownPwd() {
				if (this.downLoadPWD == this.proDetail.password) {
					this.$message({
						message: '验证成功',
						type: 'success'
					});
					this.downloadFile(this.downLoadPath)
					this.centerDialogVisible = false
				} else {
					this.$message({
						message: '密码错误',
						type: 'warning'
					});
				}
			},
			downloadImage(path) {
				// 获取图片对象和画布对象
				const imgUrl = this.getImgSrc(path)

				// 创建下载链接
				// const url = window.URL.createObjectURL(blob)
				const link = document.createElement('a')
				link.href = imgUrl
				link.download = 'image.png'
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
				// 释放 Blob URL
				// window.URL.revokeObjectURL(url)
			},
			handleExport(path, downloadName = this.proDetail.title) {
				// console.log(url);
				const url = this.getImgSrc(path)
				const link = document.createElement('a');
				fetch(url).then(res => res.blob()).then((blob) => {
					link.href = URL.createObjectURL(blob);
					// console.log(link.href)
					link.download = downloadName;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});

			},
			downloadFile(path) {
				const url = this.getImgSrc(path) + '?response-content-type=application/octet-stream'
				console.log(url)
				let a = document.createElement("a");
				a.setAttribute("href", url);
				a.setAttribute("download", this.proDetail.title);
				a.setAttribute("target", "_blank");

				a.click()
			},
			goto(url) {
				this.$router.push(url)
			},
			goHelpe() {
				this.$router.push(`/projectNeed/projectGoHelp`)
			}
		}
	}
</script>
<style scoped lang="less">
	.shareBox {
		.share {
			display: none !important;
		}

		&:hover {
			.share {
				display: flex !important;
			}
		}
	}

	.body {
		.body-right {
			&>div {
				cursor: pointer;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				line-height: 50px;
				width: 200px;
				height: 50px;
				background: #0052D9;

				&>img {
					margin-right: 15px;
				}
			}
		}

		.body-main {
			.main-body {
				.item-detail {
					.detail-line {
						display: flex;
						margin: 10px;

						p {
							width: 350px;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						span {
							color: #0052D9;
							cursor: pointer;
						}
					}

					padding:30px 15px;
				}

				margin-top: 20px;
				background: white;
				padding: 20px 0;
			}

			.main-head {
				.bottom {
					display: flex;

					span {
						font-size: 16px;
						display: flex;
						align-items: center;
					}

					margin-top: 25px;
				}

				.content {
					font-size: 16px;
					color: #222222;
					line-height: 26px;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.introduce {
					margin: 16px 0;
					display: flex;
					font-size: 14px;
					color: #888888;

					&>div {
						width: 33%;
					}
				}

				.head-right {
					flex: 1;
					padding: 8px 15px;
					box-sizing: border-box;

					.title {
						font-size: 20px;
						font-weight: bold;
					}
				}

				display: flex;
				padding: 19px;
				box-sizing: border-box;
				width: 900px;
				background: #FFFFFF;
			}

			width: 900px;

		}

		.body-left {
			.left-body {
				.guanzhu {
					width: 230px;
					height: 46px;
					background: #0052D9;
					line-height: 46px;
					color: white;
					text-align: center;
					cursor: pointer;
				}

				.body-item {
					margin: 10px 0;
					margin-bottom: 30px;
				}

				.item-title {
					font-size: 18px;
					margin-bottom: 10px;
				}

				.item-content {
					margin: 5px 0;
					color: #888888;
				}

				padding: 10px 15px;
				box-sizing: border-box;
			}

			.left-head {
				font-size: 20px;
				line-height: 69px;
				padding-left: 15px;
				box-sizing: border-box;
				font-weight: bold;
				width: 260px;
				height: 69px;
				color: #0052D9;
				background: #E5EDFB;
			}

			width: 260px;
			height: 330px;
			background: #FFFFFF;
		}

		display: flex;
		padding-bottom: 40px;
		justify-content: space-between;
	}

	.backof {
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		width: 80px;
		height: 30px;
		background: #FFFFFF;
		border: 1px solid #D2D2D2;
	}

	.header {
		width: 1400px;
		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;

		&>div {
			&>img {
				width: 16px;
				height: 16px;
			}

			&>p {
				font-size: 16px;
				margin-left: 10px;

				&>span {
					color: #888888;
				}
			}
		}
	}
	/* 弹出对话框的覆盖层 */
	.dialog-overlay {  
		
	}  
	  
	/* 对话框内容 */  
	.dialog-content {  
	  background: white;  
	  padding: 20px;  
	  border-radius: 8px;  
	  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);  
	  width: 400px; /* 稍微增加宽度以适应更大的文本域 */  
	  text-align: center;  
	}  
	  
	/* 文本域美化并放大 */  
	.text-area {  
	  width: 350px; /* 减去更大的左右padding */  
	  height: 500px; /* 增加高度 */  
	  padding: 20px; /* 增加内边距 */  
	  border: 1px solid #ccc;  
	  border-radius: 4px;  
	  box-sizing: border-box;  
	  margin-bottom: 20px;  
	  font-size: 16px; /* 增加字体大小 */  
	  line-height: 1.6; /* 稍微增加行高以保持可读性 */  
	  resize: none; /* 禁止用户调整文本域大小 */  
	}
	  
	/* 文本域美化 */  
	.text-area {  
	  width: calc(100% - 40px); /* 减去左右padding */  
	  padding: 10px;  
	  border: 1px solid #ccc;  
	  border-radius: 4px;  
	  box-sizing: border-box;  
	  margin-bottom: 20px;  
	  font-size: 14px;  
	  line-height: 1.5;  
	  resize: none; /* 禁止用户调整文本域大小 */  
	}  
	  
	/* 对话框底部按钮样式 */  
	.dialog-footer {  
	  display: flex;  
	  justify-content: center;  
	  gap: 10px; /* 按钮间的间距 */  
	}  
	  
	.submit-btn, .cancel-btn {  
	  padding: 10px 20px;  
	  font-size: 16px;  
	  border: none;  
	  border-radius: 4px;  
	  cursor: pointer;  
	  transition: background-color 0.3s; /* 添加过渡效果 */  
	}  
	  
	.submit-btn {  
	  background-color: #4CAF50; /* 绿色 */  
	  color: white;  
	}  
	  
	.submit-btn:hover {  
	  background-color: #45a049; /* 悬停时颜色变深 */  
	}  
	  
	.cancel-btn {  
	  background-color: #f44336; /* 红色 */  
	  color: white;  
	}  
	  
	.cancel-btn:hover {  
	  background-color: #da190b; /* 悬停时颜色变深 */  
	}  
</style>